<template>
  <div>
    <el-row>
      <el-col>
        <executive-board-member-menu></executive-board-member-menu>
      </el-col>
      <el-col>
        <executive-board-member-applications-lane :assignedApplications="assignedApplications"></executive-board-member-applications-lane>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ExecutiveBoardMemberMenu from './roleSpecific/ExecutiveBoardMemberMenu'
import ExecutiveBoardMemberApplicationsLane from './common/ExecutiveBoardMemberApplicationsLane'
// import axios from 'axios'
export default {
  name: 'ExecutiveBoardMember',
  components: {
    ExecutiveBoardMemberApplicationsLane,
    ExecutiveBoardMemberMenu
  },
  data () {
    return {
      activeName: 'first',
      loadAssignedApps: false
    }
  },
  methods: {
  },
  computed: {
    ...mapState([
      'assignedApplications',
      'loadingAssignedApplications',
      'workingApplication',
      'loadingWorkingApplication',
      'showWorkingApplication'
    ])
  },
  watch: {
  }
}
</script>

<style lang="scss">
.swimlane {
  padding: 2px 2px 2px 2px !important;
  &-header{
    text-align: center;
  }
}
.leftmenu {
  word-wrap: break-word;
}
.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
}

.list-group-item i{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ExecutiveBoardMember.vue